import LanguageContext from './LanguageContext';
import { useContext } from 'react';

function useLanguage() {
  const context = useContext(LanguageContext);
  return context.text;
}

export default useLanguage;
